<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <ViolationAcknowledged
      :Acknowledged="Acknowledged"
      @clicked="AcknowledgedEmit"
    />
    <SentViolationDialog
      :ViolationSent="ViolationSent"
      @clicked="ViolationSentEmit"
    />
    <v-dialog
      v-model="dialogAddViolation"
      persistent
      max-width="1000px"
      transition="dialog-top-transition"
      content-class="DialogOpenFromTop"
      class="DialogAlign"
    >
      <v-card>
        <v-toolbar dark dense class="elevation-0" color="primary">
          <div class="white--text">Send Violation</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAddViolationEmit(1)"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="text-center pb-0 mt-4">
          <v-form ref="form">
            <v-autocomplete
              dense
              outlined
              label="Select Violation"
              class="borderRadius field_height field_label_size fontsize12px"
              v-model="violation_id"
              :items="sortedViolationsList"
              item-text="violation_name"
              item-value="violation_id"
              return-object
            >
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item
                  v-bind="attrs"
                  v-on="on"
                  @click="$emit('input', item.violation_id)"
                >
                  <v-icon
                    v-if="isFavourite(item.violation_id)"
                    small
                    color="primary"
                    class="mx-1"
                  >
                    mdi-star
                  </v-icon>
                  <div v-else class="ml-6"></div>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.violation_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="borderRadius text-capitalize"
            color="primary"
            outlined
            @click="dialogAddViolationEmit(1)"
            ><v-icon small class="mr-1">mdi-close</v-icon>Cancel</v-btn
          >
          <v-btn
            small
            class="borderRadius text-capitalize mr-2"
            color="primary"
            :loading="ShareLoading"
            @click="validateMethod()"
            ><v-icon small class="mr-1">mdi-share</v-icon>Send</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { InitiateViolation } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";

import { GetAllViolations } from "@/mixins/GetAllViolations.js";
import Snackbar from "@/components/Extras/Snackbar.vue";
import ViolationAcknowledged from "@/components/Violations/Dialogs/ViolationAcknoledged.vue";
import SentViolationDialog from "@/components/Violations/Dialogs/SentViolationDialog.vue";
export default {
  props: {
    GetVehicleDetailsObject: Object,
    license_plate_number: String,
    dialogAddViolation: Boolean,
    StoreObj: Object,
  },
  components: {
    Snackbar,
    ViolationAcknowledged,
    SentViolationDialog,
  },
  mixins: [GetAllViolations],
  data: () => ({
    count: 3,
    Toggle: 0,
    logoutInterval: -1,

    violation_id: "",

    ShareLoading: false,
    ViolationSent: false,
    Acknowledged: false,
    SnackBarComponent: {},
    ViolationSentName: [],
  }),
  computed: {
    sortedViolationsList() {
      if (
        this.$store.getters.get_current_user_details.favourite_violations &&
        this.$store.getters.get_current_user_details.favourite_violations
          .length > 0
      ) {
        const userFavouriteIds =
          this.$store.getters.get_current_user_details.favourite_violations &&
          this.$store.getters.get_current_user_details.favourite_violations.map(
            (v) => v.violation_id
          );
        const favouriteViolations = this.GetAllViolationsList.filter((v) =>
          userFavouriteIds.includes(v.violation_id)
        );
        const otherViolations = this.GetAllViolationsList.filter(
          (v) => !userFavouriteIds.includes(v.violation_id)
        );
        return [...favouriteViolations, ...otherViolations];
      } else {
        return this.GetAllViolationsList;
      }
    },
  },
  watch: {
    dialogAddViolation(val) {
      if (val == true) {
        this.violation_id = "";
        this.GetAllViolationsMethod();
      }
    },
  },
  mounted() {},
  methods: {
    validateMethod() {
      if (this.$refs.form.validate()) {
        this.initiateViolationMethod();
      }
    },
    isFavourite(violationId) {
      const result =
        this.$store.getters.get_current_user_details.favourite_violations &&
        this.$store.getters.get_current_user_details.favourite_violations.some(
          (v) => v.violation_id === violationId
        );
      return result;
    },
    async initiateViolationMethod() {
      var inputParams = {
        user_id: this.$store.getters.get_current_user_details.user_id,
        license_plate_number: this.license_plate_number,
        violation_id: this.violation_id.violation_id,
      };
      try {
        this.ShareLoading = true;
        let result = await API.graphql(
          graphqlOperation(InitiateViolation, {
            input: inputParams,
          })
        );
        var ResultObject = JSON.parse(result.data.InitiateViolation);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          SnackbarText: ResultObject.message,
        };
        this.dialogAddViolationEmit(2);
        // let EndLocation = [lat, lng];
        // let EndTime = new Date().getTime();

        this.ViolationSentName.push(this.violation_id.violation_name);
        this.$store.commit("SET_COMPLETE_DATA", this.ViolationSentName);

        console.log("StoredArray", this.$store.getters.get_complete_data);
        this.ShareLoading = false;
        this.ViolationSent = true;
      } catch (error) {
        this.ShareLoading = false;
        console.log("error", error);
        // this.SnackBarComponent = {
        //   SnackbarVmodel: true,
        //   SnackbarColor: "red",
        //   Top: true,
        //   SnackbarText: error.errors[0].message,
        // };
      }
    },
    dialogAddViolationEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
    AcknowledgedEmit() {
      this.Acknowledged = false;
    },
    ViolationSentEmit() {
      this.ViolationSent = false;
    },
  },
};
</script>
